
export default function About() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-[#C9A961] to-[#4A1C40] rounded-2xl opacity-20 blur-xl"></div>
              <img 
                src="https://static.readdy.ai/image/c58860c0de9290e106b8a55542714277/b1507c51408365ea6e58ffb4ede5b729.jpeg"
                alt="Dra. Barbara Marcelino Claudino - Advogada Trabalhista"
                className="relative rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
            </div>
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#4A1C40] mb-6" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Sobre Minha Trajetória
            </h2>
            
            <div className="space-y-6 text-gray-800" style={{ fontFamily: 'Inter, sans-serif' }}>
              <p className="text-lg leading-relaxed">
                Sou <strong className="text-[#4A1C40]">Bárbara Marcelino Claudino</strong>, advogada inscrita na OAB sob o nº 225.351, especialista em direito e processo do trabalho. Minha missão é defender os direitos de trabalhadores que tiveram suas garantias violadas.
              </p>

              <p className="text-base leading-relaxed">
                Ao longo da minha carreira, desenvolvi uma abordagem que une <strong>conhecimento técnico aprofundado</strong> na legislação trabalhista com um <strong>atendimento humanizado</strong>. Acredito que cada caso merece atenção individualizada e respeito às particularidades de cada situação.
              </p>

              <p className="text-base leading-relaxed">
                Meu compromisso vai além da técnica jurídica: busco estabelecer uma relação de confiança com meus clientes, oferecendo orientação clara e transparente em todas as etapas do processo, seguiremos juntos em cada etapa. A advocacia, para mim, é um instrumento de <strong>justiça social e dignidade humana!</strong>
              </p>

              <div className="bg-[#4A1C40] rounded-xl p-6 mt-8">
                <h3 className="text-xl font-bold text-[#C9A961] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
                  Meus Valores Profissionais
                </h3>
                <ul className="space-y-3 text-white text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#C9A961] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Ética:</strong> Atuação rigorosamente alinhada ao Código de Ética da OAB</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#C9A961] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Transparência:</strong> Comunicação clara sobre possibilidades e limitações de cada caso</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#C9A961] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Compromisso:</strong> Dedicação integral à defesa dos interesses dos meus clientes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#C9A961] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Humanização:</strong> Atendimento respeitoso e acolhedor em momentos difíceis</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
